import { storeCreator } from '@/utils/store/store.utils';

import { CopaysOptionValues, RenewalPlanOptionValues, RenewalSetupStep } from '../RenewalSetup.types';

export type StepOption = RenewalPlanOptionValues | CopaysOptionValues;
export type RenewalSetupStepKey =
  | RenewalSetupStep.PlansPlanYear
  | RenewalSetupStep.HealthPlans
  | RenewalSetupStep.Copays;
export interface StepState {
  selectedOption?: StepOption;
  isOptionChosen?: boolean;
  isSubmitted?: boolean;
  isFailed?: boolean;
}

interface State {
  [RenewalSetupStep.PlansPlanYear]: StepState;
  [RenewalSetupStep.HealthPlans]: StepState;
  [RenewalSetupStep.Copays]: StepState;
  setStepState: (step: RenewalSetupStepKey, data: Partial<StepState>) => void;
  handleReset: () => void;
  planDetailsNote: string;
  setPlanDetailsNote: (note: string) => void;
  healthPlanDetailsNote: string;
  setHealthPlanDetailsNote: (note: string) => void;
  isRevalidationPending: boolean;
  setIsRevalidationPending: (value: boolean) => void;
  serverInvalidCodes: Partial<Record<RenewalSetupStepKey, string[]>>;
  setServerInvalidCodes: (step: RenewalSetupStepKey, codes: string[]) => void;
}

const initialStepState: StepState = {
  selectedOption: undefined,
  isSubmitted: false,
  isOptionChosen: false,
  isFailed: false,
};

const useRenewalSetupStore = storeCreator<State>((set) => ({
  plansPlanYear: { ...initialStepState },
  healthPlans: { ...initialStepState },
  copays: { ...initialStepState },
  planDetailsNote: '',
  healthPlanDetailsNote: '',
  isRevalidationPending: false,
  setIsRevalidationPending: (value) => set(() => ({ isRevalidationPending: value })),
  serverInvalidCodes: {},
  setServerInvalidCodes: (step, codes) =>
    set((state) => ({
      serverInvalidCodes: { ...state.serverInvalidCodes, [step]: codes },
    })),
  setStepState: (step, data) =>
    set((state) => ({
      [step]: { ...state[step], ...data },
    })),
  setPlanDetailsNote: (note: string) =>
    set((state) => ({
      ...state,
      planDetailsNote: note,
    })),
  setHealthPlanDetailsNote: (note: string) =>
    set((state) => ({
      ...state,
      healthPlanDetailsNote: note,
    })),
  handleReset: () =>
    set(() => ({
      plansPlanYear: { ...initialStepState },
      healthPlans: { ...initialStepState },
      copays: { ...initialStepState },
      planDetailsNote: '',
      healthPlanDetailsNote: '',
      isRevalidationPending: false,
      serverInvalidCodes: {},
    })),
}));

export default useRenewalSetupStore;
